import AchievementCollection from './AchievementCollection';
import DailyBadgeArt from './DailyBadgeArt';
import ResultDialog242 from './ResultDialog242';
import DailyBadgesPanel from './DailyBadgesPanel';
import { ChevronRight } from 'lucide-react';
import PageHeader from './PageHeader';
import { getApiUrl } from '../config/serverEndpoint';
import React, { useEffect, useState, useRef } from 'react';
const {DAILY_BADGES}=require('../utils/dailyBadges');
const { ACHIEVEMENTS, achievementProgress } = require('../utils/achievements');


export function progressLabel(item,value,target){
 if(item.recordSize)return target?`${value} kelime · Rekor ${target}`:`${value} kelime · Henüz rekor yok`;
 const units={totalGames:'maç',wins:'galibiyet',bestWinStreak:'ardışık galibiyet',bestScore:'en yüksek puan'};
 return `${value} ${item.boardWins?'tahta boyutunda galibiyet':units[item.metric]||''} · Hedef ${target}`;
}

export default function AchievementsScreen({ username, onBack, snapshotData=null }) {
  const [stats, setStats] = useState(snapshotData?.stats||{});
  const [onlyEarned,setOnlyEarned]=useState(false);
  const [celebration,setCelebration]=useState([]);const knownEarned=useRef(null);
  useEffect(()=>{knownEarned.current=null;setCelebration([]);},[username]);
  const [board, setBoard] = useState({ totalScore: [], averageScore: [], records: {} });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(!snapshotData);
  const refresh = async () => {
    try {
      const [statResponse, boardResponse] = await Promise.all([
        fetch(getApiUrl(`/get-player-stats?username=${encodeURIComponent(username)}`)), fetch(getApiUrl('/leaderboard')),
      ]);
      if (!statResponse.ok || !boardResponse.ok) throw new Error('Bilgiler yüklenemedi. Tekrar dene.');
      setStats(await statResponse.json());
      setBoard(await boardResponse.json());
      setError('');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); window.addEventListener('kelimo-player-name-updated', refresh);window.addEventListener('kelimo-badges-updated',refresh);window.addEventListener('focus',refresh);return()=>{window.removeEventListener('kelimo-player-name-updated',refresh);window.removeEventListener('kelimo-badges-updated',refresh);window.removeEventListener('focus',refresh);}; }, [username]);
  const selectBadge = async badgeId => {
    try {
      const response = await fetch(getApiUrl('/showcase-badge'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, reconnectToken: sessionStorage.getItem('reconnectToken'), badgeId }),
      });
      if (!response.ok) throw new Error((await response.json()).error || 'Rozet seçilemedi.');
      setStats(current => ({ ...current, showcasedBadge: badgeId }));
      window.dispatchEvent(new CustomEvent('kelimo-badges-updated',{detail:{username}}));
      setError('');
    } catch (err) { setError(err.message); }
  };
  useEffect(()=>{
   if(loading)return;
   const earned=[...ACHIEVEMENTS.filter(item=>achievementProgress(item,stats,board.records).earned).map(b=>({...b,name:b.title})),...DAILY_BADGES.filter(b=>stats.dailyBadges?.[b.id]?.count>0)];
   const previous=knownEarned.current;knownEarned.current=new Set(earned.map(b=>b.id));
   if(previous){const added=earned.filter(b=>!previous.has(b.id));if(added.length)setCelebration(added);}
  },[stats,board,loading]);
  const unlocked = ACHIEVEMENTS.filter(item => achievementProgress(item, stats, board.records).earned).length;
  const nextGoal=ACHIEVEMENTS.map(item=>({...item,...achievementProgress(item,stats,board.records)})).filter(item=>!item.earned&&item.target>0).sort((a,b)=>(b.value/b.target)-(a.value/a.target))[0];
  const displayedGoal=onlyEarned?null:nextGoal;
  const selected = ACHIEVEMENTS.find(item => item.id === stats.showcasedBadge && achievementProgress(item, stats, board.records).earned)||DAILY_BADGES.filter(b=>stats.dailyBadges?.[b.id]?.count>0).map(b=>({...b,title:b.name})).find(b=>b.id===stats.showcasedBadge);
  return <main className="kelimo-ui kelimo-page achievements-page min-h-[100dvh] bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 px-4 py-5 text-white"><PageHeader title="Başarımlar" onBack={onBack} />
    <div className="mx-auto max-w-4xl">

      {loading ? <p className="mt-4">Yükleniyor…</p> : <>
        {error && <div role="alert" className="mt-3 rounded-xl bg-red-950 p-3">{error} <button type="button" onClick={refresh} className="ml-2 underline">Tekrar dene</button></div>}
        <AchievementCollection username={username} stats={stats} records={board.records||{}} onlyEarned={onlyEarned} setOnlyEarned={setOnlyEarned} onSelectBadge={selectBadge} onRefresh={refresh}/>
        <p className="achievement-ranking-note242">Günlük ve genel puan tablosunu ana menüdeki Sıralama ekranından inceleyebilirsin.</p>
      </>}
    </div>
    {celebration.length>0&&<ResultDialog242 title="Yeni başarı kazandın" subtitle={celebration.map(b=>b.name).join(' · ')} badges={celebration} onClose={()=>setCelebration([])}><p>Yeni rozetlerin koleksiyonuna eklendi. Kazandıklarını profilinde sergileyebilirsin.</p></ResultDialog242>}
  </main>;
}
